<template>
  <b-container class="container-rda">
    <b-row>
      <b-col class="content">
        <b-row>
          <b-col>
            <Breadcrumb :breadcrumb="breadcrumb" :showBackButton="true" />
          </b-col>
        </b-row>

        <b-row class="mb-5">
          <b-col md="9">
            <h2 class="purple bold">Registros de Aprendizagem</h2>
          </b-col>
        </b-row>

        <LearningRecordHeader
          :student-photo="studentPhoto"
          :student-name="studentName"
          :subject="subject"
          :cycle="cycle"
          :cycle-year="cycleYear"
        />

        <b-row>
          <b-col>
            <h4 style="color: #b23066">Seleção de Ciclos</h4>
            <SelectSingle
              v-model="selectedCycle"
              :options="cyclesList"
              :trackBy="'name'"
              :callback="(event) => changeCycle(event)"
              v-if="cyclesList.length > 0"
            />

            <pendency-edit-modal
              modal-id="modal-edit-evidence"
              :value="pendencyText"
              :loading="showSpinner"
              @save="savePendencie"
              @close="pendencyText = null"
            />

            <template
              v-if="
                subject && subject.Competences && subject.Competences.length
              "
            >
              <div class="viewRDA">
                <b-row>
                  <b-col cols="12" style="padding-left: 10px">
                    <div
                      class="title-viewRDA title-view-rda"
                      :id="`Title-${selectedCycle.id}`"
                    >
                      <b>{{ subject.designation }}</b>
                    </div>
                  </b-col>
                </b-row>

                <div
                  v-for="(item, competenceIndex) in competencesWithoutModality(
                    subject.Competences
                  )"
                  :key="`competence-${competenceIndex}`"
                >
                  <b-row
                    :key="`no-modality-${competenceIndex}`"
                    :id="`List-${cycle.id}-${item.id}`"
                    class="rda-viewlist"
                    style="padding-left: 0"
                  >
                    <b-col cols="12" style="padding-left: 1px !important">
                      <b-row>
                        <b-col cols="7" style="padding-left: 10px">
                          <b-row
                            class="title-align"
                            v-if="item.details"
                            style="max-width: 832px !important"
                          >
                            <h4 class="competence-details">
                              {{ item.details }}
                            </h4>
                          </b-row>
                          <b-row
                            class="title-align"
                            v-if="item.TematicUnit"
                            style="max-width: 832px !important"
                          >
                            <h4 class="tematic-unit-title">
                              {{ competenceIndex + 1 }} - Unidade Temática:
                              {{ item.TematicUnit.description }}
                            </h4>
                          </b-row>
                          <b-row class="title-align">
                            <h5
                              class="title comp-description"
                              :id="`Subject-${item.id}`"
                            >
                              {{ !item.TematicUnit ? competenceIndex + 1 : "" }}
                              Competência: {{ item.description }}
                            </h5>
                          </b-row>
                        </b-col>
                        <b-col
                          class="title d-flex justify-content-center align-items-center"
                          cols="3"
                          style="padding-right: 9% !important"
                        >
                          Status
                        </b-col>
                        <b-col class="title" cols="1"> Avaliar </b-col>
                        <b-col class="title" cols="1"> Evidência </b-col>
                      </b-row>
                    </b-col>

                    <b-col
                      cols="12"
                      v-for="(topic, topicIndex) in item.Topics"
                      :key="`student-${topicIndex}`"
                      style="padding-left: 0 !important"
                    >
                      <b-row class="list-teacher item-rda-viewlist">
                        <b-col cols="7" class="text-col">
                          <p class="knowledge-object-title">
                            {{
                              topic.KnowledgeObject
                                ? `${competenceIndex + 1}.${
                                    topicIndex + 1
                                  } - Objeto de Conhecimento:
                            ${topic.KnowledgeObject.description}`
                                : ""
                            }}
                          </p>
                          <p class="topic-description">
                            {{
                              !topic.KnowledgeObject
                                ? `${competenceIndex + 1}.${topicIndex + 1}`
                                : ""
                            }}
                            Conteúdo: {{ topic.description }}
                          </p>
                          <div
                            class="prof-data"
                            v-if="
                              topic.TopicStudents[0].status &&
                              !pendingTopicUpdates[topic.id]
                            "
                          >
                            <span
                              >Atualizado por
                              <b>{{
                                topic.TopicStudents[0].editor
                                  ? topic.TopicStudents[0].editor.name
                                  : ""
                              }}</b>
                              •
                              {{
                                formatDate(topic.TopicStudents[0].updated_at)
                              }}</span
                            >
                          </div>
                        </b-col>

                        <b-button
                          :id="topic.TopicStudents[0].topic_id"
                          class="evidence-btn"
                          v-if="
                            topic.TopicStudents[0].status === 'AN' &&
                            checkIfRoleIsHigh()
                          "
                          @click="
                            registerEvidence(
                              topic.TopicStudents[0].topic_id,
                              topic.TopicStudents[0].student_id,
                              topic.TopicStudents[0].pendency
                            )
                          "
                        >
                          Pendência
                        </b-button>

                        <b-col cols="3" style="padding-left: 18px !important">
                          <div class="status-grid">
                            <span
                              v-for="(status, statusIndex) in learningStatus"
                              :key="statusIndex"
                              :id="`Status-${topic.id}`"
                              @click="
                                canEditAStatus ||
                                (topic.TopicStudents[0].status !== 'A' &&
                                  topic.TopicStudents[0].status !== '*')
                                  ? updateTopicSingle({
                                      status,
                                      topic_id: topic.id,
                                      current: topic.TopicStudents[0].status,
                                    })
                                  : null
                              "
                              :style="
                                canEditAStatus ||
                                (topic.TopicStudents[0].status !== 'A' &&
                                  topic.TopicStudents[0].status !== '*')
                                  ? 'cursor: pointer'
                                  : 'cursor: not-allowed'
                              "
                            >
                              <p
                                :id="`Upload-${topic.TopicStudents[0].id}`"
                                :class="`tags ${
                                  topic.TopicStudents[0].status === status
                                    ? 'warning'
                                    : 'info'
                                }`"
                              >
                                {{ status }}
                              </p>
                            </span>
                          </div>
                        </b-col>

                        <b-col cols="1">
                          <div class="actions-grid">
                            <span
                              :id="`Evaluation-${topic.id}`"
                              @click="
                                updateEvaluationTopic({
                                  topic_id: topic.id,
                                  status:
                                    topic.TopicStudents[0].is_for_evaluation,
                                })
                              "
                            >
                              <RateIcon
                                :id="`EvaluationIconNew-${topic.id}-${index}`"
                                :ref="`evaluationIconRefNew_${topic.id}_${index}`"
                                class="pointer"
                                :class="{
                                  inactive:
                                    !topic.TopicStudents[0].is_for_evaluation,
                                }"
                              />
                            </span>
                          </div>
                        </b-col>

                        <b-col cols="1">
                          <div class="actions-grid">
                            <label class="pointer">
                              <LearningUploadIcon
                                :id="
                                  'addFileInputNew_' +
                                  topicIndex +
                                  '_' +
                                  topicIndex
                                "
                                :ref="
                                  'addFileInputRefNew_' +
                                  topicIndex +
                                  '_' +
                                  topicIndex
                                "
                              />
                              <input
                                hidden
                                @change="
                                  () =>
                                    uploadEvidence(
                                      topicIndex,
                                      topic.id,
                                      'addFileInput_'
                                    )
                                "
                                type="file"
                                accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf"
                                name="file"
                                :id="'addFileInput_' + topicIndex"
                                :ref="'addFileInput_' + topicIndex"
                              />
                            </label>
                          </div>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </div>

                <div v-if="hasLanguageCompetences(subject.Competences)">
                  <div
                    class="mb-2"
                    style="
                      display: flex;
                      align-items: center;
                      padding-left: 20px;
                    "
                  >
                    <span
                      style="
                        display: inline-block;
                        width: 18px;
                        height: 18px;
                        background: #28a745;
                        border-radius: 4px;
                        margin-right: 8px;
                      "
                    ></span>
                    <span style="font-size: 15px; color: #495057"
                      >Níveis ativos</span
                    >
                  </div>
                  <div
                    v-for="(levelGroup, levelName) in groupedLanguagesByLevel(
                      subject.Competences
                    )"
                    :key="`language-level-${levelName}`"
                    class="level-group col-12"
                  >
                    <b-card-header
                      header-tag="header"
                      role="tab"
                      :style="{
                        border: '1px solid #dee2e6',
                        borderRadius: '10px',
                        cursor: 'pointer',
                        borderLeft: !levelLanguageDisabled[levelName]
                          ? '4px solid #28a745'
                          : '1px solid #dee2e6',
                      }"
                      v-b-toggle="
                        'accordion-language-level-' +
                        getLevelId('language', levelName)
                      "
                      class="accordion-header"
                    >
                      <h5 style="color: #b23066">
                        {{ levelName }}
                      </h5>
                    </b-card-header>

                    <b-collapse
                      :id="
                        'accordion-language-level-' +
                        getLevelId('language', levelName)
                      "
                      role="tabpanel"
                    >
                      <b-row
                        v-for="item in levelGroup"
                        :key="`language-competence-${item.id}`"
                        class="rda-viewlist"
                        style="padding-left: 0"
                      >
                        <b-col cols="12" style="padding-left: 1px !important">
                          <b-row>
                            <b-col cols="7" style="padding-left: 10px">
                              <b-row
                                class="title-align"
                                v-if="item.TematicUnit"
                                style="max-width: 832px !important"
                              >
                                <h4 class="tematic-unit-title">
                                  {{ item.sort_order }} - Unidade Temática:
                                  {{ item.TematicUnit.description }}
                                </h4>
                              </b-row>
                              <b-row class="title-align">
                                <h5
                                  class="title comp-description"
                                  :id="`Subject-${item.id}`"
                                >
                                  {{ !item.TematicUnit ? item.sort_order : "" }}
                                  Competência: {{ item.description }}
                                </h5>
                              </b-row>
                            </b-col>
                            <b-col
                              class="title d-flex justify-content-center align-items-center"
                              cols="3"
                              style="padding-right: 9% !important"
                            >
                              Status
                            </b-col>
                            <b-col class="title" cols="1"> Avaliar </b-col>
                            <b-col class="title" cols="1"> Evidência </b-col>
                          </b-row>
                        </b-col>
                        <b-col
                          cols="12"
                          v-for="(topic, topicIndex) in item.Topics"
                          :key="`student-${topicIndex}`"
                          style="padding-left: 0 !important"
                        >
                          <b-row class="list-teacher item-rda-viewlist">
                            <b-col cols="7" class="text-col">
                              <p class="knowledge-object-title">
                                {{
                                  topic.KnowledgeObject
                                    ? `${item.sort_order}.${
                                        topicIndex + 1
                                      } - Objeto de Conhecimento:
                                ${topic.KnowledgeObject.description}`
                                    : ""
                                }}
                              </p>
                              <p class="topic-description">
                                {{
                                  !topic.KnowledgeObject
                                    ? `${item.sort_order}.${topicIndex + 1}`
                                    : ""
                                }}
                                Conteúdo: {{ topic.description }}
                              </p>
                              <div
                                class="prof-data"
                                v-if="
                                  topic.TopicStudents[0].status &&
                                  !pendingTopicUpdates[topic.id]
                                "
                              >
                                <span
                                  >Atualizado por
                                  <b>{{
                                    topic.TopicStudents[0].editor
                                      ? topic.TopicStudents[0].editor.name
                                      : ""
                                  }}</b>
                                  •
                                  {{
                                    formatDate(
                                      topic.TopicStudents[0].updated_at
                                    )
                                  }}</span
                                >
                              </div>
                            </b-col>

                            <b-button
                              :id="topic.TopicStudents[0].topic_id"
                              class="evidence-btn"
                              v-if="
                                topic.TopicStudents[0].status === 'AN' &&
                                checkIfRoleIsHigh()
                              "
                              @click="
                                registerEvidence(
                                  topic.TopicStudents[0].topic_id,
                                  topic.TopicStudents[0].student_id,
                                  topic.TopicStudents[0].pendency
                                )
                              "
                            >
                              Pendência
                            </b-button>

                            <b-col
                              cols="3"
                              style="padding-left: 18px !important"
                            >
                              <div class="status-grid">
                                <span
                                  v-for="(
                                    status, statusIndex
                                  ) in learningStatus"
                                  :key="statusIndex"
                                  :id="`Status-${topic.id}`"
                                  @click="
                                    canEditAStatus ||
                                    (topic.TopicStudents[0].status !== 'A' &&
                                      topic.TopicStudents[0].status !== '*')
                                      ? updateTopicSingle({
                                          status,
                                          topic_id: topic.id,
                                          current:
                                            topic.TopicStudents[0].status,
                                        })
                                      : null
                                  "
                                  :style="
                                    canEditAStatus ||
                                    (topic.TopicStudents[0].status !== 'A' &&
                                      topic.TopicStudents[0].status !== '*')
                                      ? 'cursor: pointer'
                                      : 'cursor: not-allowed'
                                  "
                                >
                                  <p
                                    :id="`Upload-${topic.TopicStudents[0].id}`"
                                    :class="`tags ${
                                      topic.TopicStudents[0].status === status
                                        ? 'warning'
                                        : 'info'
                                    }`"
                                  >
                                    {{ status }}
                                  </p>
                                </span>
                              </div>
                            </b-col>

                            <b-col cols="1">
                              <div class="actions-grid">
                                <span
                                  :id="`Evaluation-${topic.id}`"
                                  @click="
                                    updateEvaluationTopic({
                                      topic_id: topic.id,
                                      status:
                                        topic.TopicStudents[0]
                                          .is_for_evaluation,
                                    })
                                  "
                                >
                                  <RateIcon
                                    :id="`EvaluationIconNew-${topic.id}-${index}`"
                                    :ref="`evaluationIconRefNew_${topic.id}_${index}`"
                                    class="pointer"
                                    :class="{
                                      inactive:
                                        !topic.TopicStudents[0]
                                          .is_for_evaluation,
                                    }"
                                  />
                                </span>
                              </div>
                            </b-col>

                            <b-col cols="1">
                              <div class="actions-grid">
                                <label class="pointer">
                                  <LearningUploadIcon
                                    :id="
                                      'addFileInputNew_' +
                                      topicIndex +
                                      '_' +
                                      topicIndex
                                    "
                                    :ref="
                                      'addFileInputRefNew_' +
                                      topicIndex +
                                      '_' +
                                      topicIndex
                                    "
                                  />
                                  <input
                                    hidden
                                    @change="
                                      () =>
                                        uploadEvidence(
                                          topicIndex,
                                          topic.id,
                                          'addFileInput_'
                                        )
                                    "
                                    type="file"
                                    accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf"
                                    name="file"
                                    :id="'addFileInput_' + topicIndex"
                                    :ref="'addFileInput_' + topicIndex"
                                  />
                                </label>
                              </div>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-collapse>
                  </div>
                </div>

                <div v-else>
                  <div
                    v-for="(
                      modalityLevels, modalityName
                    ) in groupedByModalityAndLevel(subject.Competences)"
                    :key="`modality-${modalityName}`"
                  >
                    <div
                      :key="`modality-${modalityName}`"
                      class="modality-group"
                    >
                      <b-card-header
                        header-tag="header"
                        role="tab"
                        style="
                          border: 1px solid #dee2e6;
                          border-radius: 10px;
                          cursor: pointer;
                        "
                        v-b-toggle="
                          'accordion-modality-' + getModalityId(modalityName)
                        "
                        class="accordion-header"
                      >
                        <h5 style="color: #495057">
                          {{ modalityName }}
                          {{
                            showArtPercentage
                              ? " - " + artPercentages[modalityName] + "%"
                              : ""
                          }}
                        </h5>
                      </b-card-header>

                      <b-collapse
                        :id="
                          'accordion-modality-' + getModalityId(modalityName)
                        "
                        role="tabpanel"
                      >
                        <div
                          class="mb-2"
                          style="
                            display: flex;
                            align-items: center;
                            padding-left: 20px;
                          "
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 18px;
                              height: 18px;
                              background: #28a745;
                              border-radius: 4px;
                              margin-right: 8px;
                            "
                          ></span>
                          <span style="font-size: 15px; color: #495057"
                            >Níveis ativos</span
                          >
                        </div>
                        <div
                          v-for="(levelGroup, levelName) in modalityLevels"
                          :key="`level-${levelName}`"
                          class="level-group"
                        >
                          <b-card-header
                            header-tag="header"
                            role="tab"
                            :style="{
                              border: '1px solid #dee2e6',
                              borderRadius: '10px',
                              cursor: 'pointer',
                              borderLeft: !groupedDisabled[modalityName][
                                levelName
                              ]
                                ? '4px solid #28a745'
                                : '1px solid #dee2e6',
                            }"
                            v-b-toggle="
                              'accordion-level-' +
                              getLevelId(modalityName, levelName)
                            "
                            class="accordion-header"
                          >
                            <h5
                              :style="{
                                color: '#b23066',
                              }"
                            >
                              {{ levelName }}
                            </h5>
                          </b-card-header>
                          <b-collapse
                            :id="
                              'accordion-level-' +
                              getLevelId(modalityName, levelName)
                            "
                            role="tabpanel"
                          >
                            <template
                              v-for="(item, competenceIndex) in levelGroup"
                            >
                              <b-row
                                :key="`level-item-${competenceIndex}`"
                                :id="`List-${cycle.id}-${item.id}`"
                                class="rda-viewlist modality-content"
                                style="padding-left: 0"
                              >
                                <b-col
                                  cols="12"
                                  style="padding-left: 1px !important"
                                >
                                  <b-row>
                                    <b-col cols="7" style="padding-left: 10px">
                                      <b-row
                                        class="title-align"
                                        v-if="item.TematicUnit"
                                        style="max-width: 832px !important"
                                      >
                                        <h4 class="tematic-unit-title">
                                          {{ item.sort_order }} - Unidade
                                          Temática:
                                          {{ item.TematicUnit.description }}
                                        </h4>
                                      </b-row>
                                      <b-row class="title-align">
                                        <h5
                                          class="title comp-description"
                                          :id="`Subject-${item.id}`"
                                        >
                                          {{
                                            !item.TematicUnit
                                              ? item.sort_order
                                              : ""
                                          }}
                                          Competência: {{ item.description }}
                                        </h5>
                                      </b-row>
                                    </b-col>
                                    <b-col
                                      class="title d-flex justify-content-center align-items-center"
                                      cols="3"
                                      style="padding-right: 9% !important"
                                    >
                                      Status
                                    </b-col>
                                    <b-col class="title" cols="1">
                                      Avaliar
                                    </b-col>
                                    <b-col class="title" cols="1">
                                      Evidência
                                    </b-col>
                                  </b-row>
                                </b-col>

                                <b-col
                                  cols="12"
                                  v-for="(topic, topicIndex) in item.Topics"
                                  :key="`level-student-${topicIndex}`"
                                  style="padding-left: 0 !important"
                                >
                                  <b-row class="list-teacher item-rda-viewlist">
                                    <b-col cols="7" class="text-col">
                                      <p class="knowledge-object-title">
                                        {{
                                          topic.KnowledgeObject
                                            ? `${item.sort_order}.${
                                                topicIndex + 1
                                              } - Objeto de Conhecimento:
                                        ${topic.KnowledgeObject.description}`
                                            : ""
                                        }}
                                      </p>
                                      <p class="topic-description">
                                        {{
                                          !topic.KnowledgeObject
                                            ? `${item.sort_order}.${
                                                topicIndex + 1
                                              }`
                                            : ""
                                        }}
                                        Conteúdo: {{ topic.description }}
                                      </p>
                                      <div
                                        class="prof-data"
                                        v-if="
                                          topic.TopicStudents[0].status &&
                                          !pendingTopicUpdates[topic.id]
                                        "
                                      >
                                        <span
                                          >Atualizado por
                                          <b>{{
                                            topic.TopicStudents[0].editor
                                              ? topic.TopicStudents[0].editor
                                                  .name
                                              : ""
                                          }}</b>
                                          •
                                          {{
                                            formatDate(
                                              topic.TopicStudents[0].updated_at
                                            )
                                          }}</span
                                        >
                                      </div>
                                    </b-col>

                                    <b-button
                                      :id="topic.TopicStudents[0].topic_id"
                                      class="evidence-btn"
                                      v-if="
                                        topic.TopicStudents[0].status ===
                                          'AN' && checkIfRoleIsHigh()
                                      "
                                      @click="
                                        registerEvidence(
                                          topic.TopicStudents[0].topic_id,
                                          topic.TopicStudents[0].student_id,
                                          topic.TopicStudents[0].pendency
                                        )
                                      "
                                    >
                                      Pendência
                                    </b-button>

                                    <b-col
                                      cols="3"
                                      style="padding-left: 18px !important"
                                    >
                                      <div class="status-grid">
                                        <span
                                          v-for="(
                                            status, statusIndex
                                          ) in learningStatus"
                                          :key="statusIndex"
                                          :id="`Status-${topic.id}`"
                                          @click="
                                            canEditAStatus ||
                                            (topic.TopicStudents[0].status !==
                                              'A' &&
                                              topic.TopicStudents[0].status !==
                                                '*')
                                              ? updateTopicSingle({
                                                  status,
                                                  topic_id: topic.id,
                                                  current:
                                                    topic.TopicStudents[0]
                                                      .status,
                                                })
                                              : null
                                          "
                                          :style="
                                            canEditAStatus ||
                                            (topic.TopicStudents[0].status !==
                                              'A' &&
                                              topic.TopicStudents[0].status !==
                                                '*')
                                              ? 'cursor: pointer'
                                              : 'cursor: not-allowed'
                                          "
                                        >
                                          <p
                                            :id="`Upload-${topic.TopicStudents[0].id}`"
                                            :class="`tags ${
                                              topic.TopicStudents[0].status ===
                                              status
                                                ? 'warning'
                                                : 'info'
                                            }`"
                                          >
                                            {{ status }}
                                          </p>
                                        </span>
                                      </div>
                                    </b-col>

                                    <b-col cols="1">
                                      <div class="actions-grid">
                                        <span
                                          :id="`Evaluation-${topic.id}`"
                                          @click="
                                            updateEvaluationTopic({
                                              topic_id: topic.id,
                                              status:
                                                topic.TopicStudents[0]
                                                  .is_for_evaluation,
                                            })
                                          "
                                        >
                                          <RateIcon
                                            :id="`EvaluationIconNew-${topic.id}-${competenceIndex}`"
                                            :ref="`evaluationIconRefNew_${topic.id}_${competenceIndex}`"
                                            class="pointer"
                                            :class="{
                                              inactive:
                                                !topic.TopicStudents[0]
                                                  .is_for_evaluation,
                                            }"
                                          />
                                        </span>
                                      </div>
                                    </b-col>

                                    <b-col cols="1">
                                      <div class="actions-grid">
                                        <label class="pointer">
                                          <LearningUploadIcon
                                            :id="
                                              'addFileInputNew_' +
                                              competenceIndex +
                                              '_' +
                                              topicIndex
                                            "
                                            :ref="
                                              'addFileInputRefNew_' +
                                              competenceIndex +
                                              '_' +
                                              topicIndex
                                            "
                                          />
                                          <input
                                            hidden
                                            @change="
                                              () =>
                                                uploadEvidence(
                                                  competenceIndex * 1000 +
                                                    topicIndex,
                                                  topic.id,
                                                  'addFileInput_'
                                                )
                                            "
                                            type="file"
                                            accept=".doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf"
                                            name="file"
                                            :id="
                                              'addFileInput_' +
                                              (competenceIndex * 1000 +
                                                topicIndex)
                                            "
                                            :ref="
                                              'addFileInput_' +
                                              (competenceIndex * 1000 +
                                                topicIndex)
                                            "
                                          />
                                        </label>
                                      </div>
                                    </b-col>
                                  </b-row>
                                </b-col>
                              </b-row>
                            </template>
                          </b-collapse>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="isRequestSend">
              <p class="no-competence">
                Área do conhecimento não encontrada para este ciclo.
              </p>
            </template>
          </b-col>
        </b-row>

        <template
          v-if="
            isRequestSend &&
            subject &&
            subject.Competences &&
            subject.Competences.length <= 0
          "
        >
          <p class="no-competence">
            Nenhuma competêcia cadastrada pra essa matéria.
          </p>
        </template>

        <template v-if="!isRequestSend">
          <p class="no-competence">
            Carregando
            <span class="spinner-border spinner-border-sm"></span>
          </p>
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LearningUploadIcon from "@/components/svg/LearningUploadIcon.vue";
import RateIcon from "@/components/svg/RateIcon.vue";
import SelectSingle from "../../components/inputs/SelectSingle.vue";
import httpRda from "../../http-rda";
import moment from "moment-timezone";
import PendencyEditModal from "@/components/PendencyEditModal.vue";
import LearningRecordHeader from "@/components/LearningRecordHeader.vue";

export default {
  name: "registrar-aprendizagens",
  components: {
    LearningUploadIcon,
    RateIcon,
    SelectSingle,
    PendencyEditModal,
    LearningRecordHeader,
  },

  data() {
    return {
      canEditAStatus: false,
      showSpinner: false,
      isRequestSend: false,
      topicId: null,
      studentId: null,
      pendencyText: null,
      cyclesList: [],
      selectedCycle: null,
      subject: { Competences: [] },
      learningStatus: ["EE", "AN", "A", "*", "#"],
      virtual: null,
      version: null,
      breadcrumb: [
        {
          text: "Aprendizagem",
          href: "/aprendizagem",
        },
        {
          text: "Registros de Aprendizagem",
          href: "/aprendizagem/conteudos",
        },
        {
          text: "Aluno",
          href: "/aprendizagem/registrar-aprendizagens",
          active: true,
        },
      ],
      groupedDisabled: {},
      levelLanguageDisabled: {},
      pendingTopicUpdates: {},
    };
  },

  computed: {
    ...mapGetters({
      currentUser: "auth/getAuthData",
      student: "learning/student",
      subjectList: "learning/subjectContent",
    }),
    artPercentages() {
      return this.subject.artPercentages || {};
    },
    groupedByModalityAndLevel() {
      return (competences) => {
        const grouped = {};
        let competenceSortOrderLevel = 1;

        competences.forEach((competence) => {
          if (competence.modality) {
            if (!grouped[competence.modality]) {
              grouped[competence.modality] = {};
              this.groupedDisabled[competence.modality] = {};
              competenceSortOrderLevel = 1;
            }
            const level = competence.details || "Sem Nível";

            if (!grouped[competence.modality][level]) {
              grouped[competence.modality][level] = [];
              this.groupedDisabled[competence.modality][level] = false;
            }

            grouped[competence.modality][level].push({
              ...competence,
              sort_order: competenceSortOrderLevel,
            });
            competenceSortOrderLevel++;
          }
        });

        Object.keys(grouped).forEach((modality) => {
          Object.keys(grouped[modality]).forEach((level) => {
            const allTopics = grouped[modality][level];
            const allDisabled = allTopics.every((topic) =>
              topic.Topics.every((t) => t.TopicStudents[0].status === "#")
            );
            this.groupedDisabled[modality][level] = allDisabled;
          });
        });

        return grouped;
      };
    },

    student_id() {
      return this.$route.params.id;
    },

    studentName() {
      if (!this.student.User) return "";
      return this.student.User.name;
    },

    studentPhoto() {
      if (!this.student.User) return "";
      return this.student.User.photo;
    },

    cycle() {
      if (!this.subject || !this.subject.Cycle) return "";
      return this.subject.Cycle;
    },

    cycleYear() {
      return this.student.year_id ? this.student.year_id : "";
    },
    showArtPercentage() {
      const isSchoolUser =
        this.currentUser.role.includes("teacher") ||
        this.currentUser.role.includes("coordinator") ||
        this.currentUser.role.includes("admin");
      const isStudent = this.currentUser.role.includes("student");

      return isSchoolUser && !isStudent;
    },
  },

  methods: {
    ...mapActions({
      getStudent: "learning/getStudent",
      updateStudentTopic: "learning/updateStudentTopic",
      updateStudentTopicEvaluation: "learning/updateStudentTopicEvaluation",
      updateEvidence: "learning/updateStudentFileTopic",
    }),

    hasLanguageCompetences(competences) {
      return competences.every(
        (competence) => !competence.modality && competence.details
      );
    },

    groupedLanguagesByLevel(competences) {
      const grouped = {};

      competences.forEach((competence) => {
        if (competence.details && !competence.modality) {
          const level = competence.details;

          if (!grouped[level]) {
            grouped[level] = [];
            this.levelLanguageDisabled[level] = false;
          }

          grouped[level].push({
            ...competence,
          });
        }
      });

      Object.keys(grouped).forEach((level) => {
        const allTopics = grouped[level];
        const allDisabled = allTopics.every((topic) =>
          topic.Topics.every((t) => t.TopicStudents[0].status === "#")
        );
        this.levelLanguageDisabled[level] = allDisabled;
      });

      return grouped;
    },

    getLevelId(modalityName, levelName) {
      return `${this.getModalityId(modalityName)}-${levelName
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "")}`;
    },

    competencesWithoutModality(competences) {
      return competences.filter(
        (competence) => !competence.modality && !competence.details
      );
    },

    getModalityId(modalityName) {
      return modalityName
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");
    },

    formatDate(date) {
      return moment(date)
        .tz("America/Sao_Paulo")
        .format("DD/MM/YYYY [às] HH:mm");
    },

    async savePendencie(pendency) {
      try {
        this.showSpinner = true;
        this.pendencyText = pendency;

        await this.updateStudentTopic({
          student_id: this.student_id,
          topic_id: this.topicId,
          pendency: this.pendencyText,
        });

        this.showSpinner = false;
        await this.setSubject();
        this.$bvModal.hide("modal-edit-evidence");
      } catch (error) {
        this.showSpinner = false;
        this.errorMessage(error.response.data.message);
        this.$bvModal.hide("modal-edit-evidence");
        return error.response;
      }
    },

    async updateEvaluationTopic({ topic_id, status }) {
      if (!status) {
        return;
      }
      await this.updateStudentTopicEvaluation({
        student_id: this.student_id,
        topic_id,
        is_for_evaluation: false,
      })
        .then(async () => {
          await this.setSubject();
        })
        .catch((error) => {
          this.errorMessage(error.response.data.message);
        });
    },

    async updateTopic({ topic_id, ...data }) {
      const getStatus = data.status === data.current ? "" : data.status;

      await this.updateStudentTopic({
        student_id: this.student_id,
        topic_id,
        status: getStatus,
      });

      await this.updateStudentTopicEvaluation({
        student_id: this.student_id,
        topic_id,
        is_for_evaluation: false,
      });
    },

    registerEvidence(topicId, studentId, pendency) {
      this.topicId = topicId;
      this.studentId = studentId;
      this.pendencyText = pendency;

      this.$bvModal.show("modal-edit-evidence");
    },

    checkIfRoleIsHigh() {
      return this.currentUser.role.some(
        (r) => r === "coordinator" || r === "teacher" || r === "secretary"
      );
    },

    async updateTopicSingle(params) {
      if (
        !(
          this.canEditAStatus ||
          (params.current !== "A" && params.current !== "*")
        )
      ) {
        return;
      }

      const getStatus = params.status !== params.current ? params.status : "";
      const topicStudent = this.findTopicStudent(params.topic_id);

      if (!topicStudent) {
        return;
      }

      const previousStatus = topicStudent.status;

      topicStudent.status = getStatus;
      this.$set(this.pendingTopicUpdates, params.topic_id, true);

      try {
        await this.updateTopic(params);
        await this.fetchSubjectSilently();
        this.$set(this.pendingTopicUpdates, params.topic_id, false);
        this.successMessage(
          getStatus
            ? "Status atualizado com sucesso!"
            : "Status removido com sucesso!"
        );
      } catch (error) {
        topicStudent.status = previousStatus;
        this.$set(this.pendingTopicUpdates, params.topic_id, false);
        this.errorMessage(error.response?.data?.message);
      }
    },

    async fetchSubjectSilently() {
      const { id, subject_id } = this.$route.params;
      let url = `/students/${id}/subjects/${subject_id}/list?cycle_id=${this.selectedCycle}`;

      if (this.virtual && this.version) {
        url += `&virtual=${this.virtual}&version=${this.version}`;
      }

      const response = await httpRda.get(url);
      this.subject = response.data.subjects;
    },

    findTopicStudent(topicId) {
      if (!this.subject?.Competences) {
        return null;
      }

      for (const competence of this.subject.Competences) {
        if (!competence.Topics) {
          continue;
        }

        const topic = competence.Topics.find((t) => t.id === topicId);

        if (topic?.TopicStudents?.[0]) {
          return topic.TopicStudents[0];
        }
      }

      return null;
    },

    changeCycle(data) {
      if (data && data.id) {
        if (data.id !== this.cycle.id) {
          alert("Você está saindo do ciclo atual do aluno");
        }
        this.selectedCycle = data.id;
        this.virtual = data.virtual ? data.virtual : null;
        this.version = data.version ? data.version : null;
        this.setSubject();
      }
    },

    async uploadEvidence(index, topic_id, ref) {
      const [file] = this.$refs[ref + index][0].files;
      const bodyFormData = new FormData();

      bodyFormData.append("file", file);

      try {
        this.loading();
        await this.updateEvidence({
          student_id: this.student_id,
          topic_id,
          file: bodyFormData,
        });

        this.loading(false);
        this.successMessage();
      } catch (error) {
        this.errorMessage(error.response.data.message);
        this.loading(false);
        return error.response;
      }
    },

    async getCycles() {
      const { id } = this.$route.params;

      const cycles = await httpRda
        .get(`/tutoring/student/${id}/cycles`)
        .then((resp) => resp.data.cycles);

      this.cyclesList = cycles.map((c) => {
        return {
          id: c.id,
          name: c.designation,
          virtual: c.virtual,
          version: c.version,
        };
      });

      if (!this.selectedCycle) {
        this.selectedCycle = this.cyclesList[0].id;
      }
    },

    async setSubject() {
      if (!this.selectedCycle) {
        return;
      }
      this.isRequestSend = false;
      this.subject = { Competences: [] };
      const { id, subject_id } = this.$route.params;

      let url = `/students/${id}/subjects/${subject_id}/list?cycle_id=${this.selectedCycle}`;

      if (this.virtual && this.version) {
        url += `&virtual=${this.virtual}&version=${this.version}`;
      }

      await httpRda
        .get(url)
        .then((response) => {
          this.subject = response.data.subjects;
        })
        .catch((error) => {
          return error;
        });

      this.isRequestSend = true;
    },

    successMessage(title = "Evidência enviada com sucesso!") {
      this.$toast.open({
        message: title,
        type: "success",
        duration: 2000,
      });
    },

    errorMessage(message = null) {
      this.$toast.open({
        message: message || "Não foi possivel atualizar!",
        type: "error",
        duration: 2000,
      });
    },

    loading(show = true) {
      if (!show) {
        return this.$swal.close();
      }
      this.$swal.fire({
        title: "Carregando arquivo...",
        onBeforeOpen: () => {
          this.$swal.showLoading();
        },
      });
    },
  },

  async created() {
    this.$store.commit("learning/SET_STUDENT", { student: {} });
    await this.getCycles();
    const { id, subject_id } = this.$route.params;

    if (!id || !subject_id) return this.$router.push("/");

    await this.setSubject();
    await this.getStudent(+id);
    this.canEditAStatus = this.currentUser.role.some(
      (r) => r === "coordinator" || r === "admin"
    );
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.evidence-btn {
  border-radius: 5px;
  background-color: #68c5b7;
  color: white;
  border: none;
}

.modality-group {
  margin-bottom: 20px;

  .modality-content {
    padding-left: 20px;
    background-color: #f8f9fa;
    border-radius: 0 5px 5px 0;
    padding-top: 15px;
  }
}

::v-deep .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #f7f7f7;
  border-bottom: 1px solid #dee2e6;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);

  h5 {
    margin: 0;
    cursor: pointer;
    color: #495057;
    font-weight: 600;

    &:hover {
      color: #007bff;
    }
  }
}

::v-deep .collapse {
  border: 1px solid #dee2e6;
  border-top: none;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  padding: 1rem;
}

.info {
  background-color: #b3b3b3;
}

.status-grid {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;

  p {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
  }
}

.actions-grid {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tab-content {
  .nav-tabs {
    border-bottom: 2px solid #e6e6e6;
    gap: 24px;

    li {
      &:first-child {
        a {
          text-align: left;
          padding: 0;
        }
      }
    }

    .nav-link {
      text-align: center;
      font-size: 18px;
      color: #1a1a1a;
      height: 52px;
      border: 0;
      padding: 0 18px;
      position: relative;

      &.active {
        font-weight: bold;
        background: transparent;

        &:after {
          width: 100%;
        }
      }

      &:after {
        background: $gradient1;
        content: "";
        width: 0;
        height: 4px;
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        border-radius: 50px;
        transition: 0.2s all ease-in-out;
      }
    }
  }
}

ul,
li {
  padding: 0;
}

.home {
  height: 100%;
}

.blue {
  color: $blue;
}

.prof-data {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 4px;

  span {
    font-size: 12px;
    color: #939393;

    b {
      font-weight: bold;
    }
  }

  time {
    font-size: 10px;
    color: #939393;
  }
}

.profile-row {
  background: $gradient3;
  border-radius: 10px;
  color: $white;
  margin: 30px 0 60px;
  padding: 28px 10px;
  position: relative;

  &:after {
    content: url("~@/assets/images/watermark-profile.png");
    right: 0;
    pointer-events: none;
    position: absolute;
    top: -5px;
  }

  .col {
    display: flex;
    align-items: center;

    img {
      margin-right: 40px;
    }

    .content-meeting {
      display: flex;
      width: 100%;

      .column {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 60px;
        min-width: 250px;
        margin-right: 30px;

        &.two {
          min-width: 650px;
        }

        .learning-progress {
          display: inline-flex;
          align-items: center;
          margin-left: 10px;
          width: 50%;

          .progress {
            width: 100%;
            margin-left: 15px;

            &.white {
              background-color: transparent;
              border: 1px solid $white;

              .progress-bar {
                background-color: $white;
              }
            }
          }
        }
      }

      h5 {
        margin: 0;
      }

      p {
        margin: 0;
      }
    }
  }
}

.progress {
  border-radius: 30px;
  height: 7px;

  .progress-bar {
    background-color: $purple;
  }

  &.orange {
    .progress-bar {
      background-color: $orange2;
    }
  }

  &.yellow {
    .progress-bar {
      background-color: $yellow;
    }
  }

  &.red {
    .progress-bar {
      background-color: $red;
    }
  }

  &.green {
    .progress-bar {
      background-color: $green2;
    }
  }
}

.container-rda {
  padding-bottom: 0;
}

.learning-date {
  background-color: $purple;
  border-radius: 6px;
  color: $white;
  line-height: 28px;
  max-width: 82px;
  text-align: center;
  width: 100%;
}

.learning-tags {
  font-size: 0;

  span {
    background-color: $grey5;
    border-radius: 6px;
    color: $white;
    display: inline-block;
    font-size: 18px;
    line-height: 28px;
    margin-right: 12px;
    max-width: 34px;
    width: 100%;
    text-align: center;

    &.active {
      background-color: $blue;
    }

    &.active + span {
      cursor: pointer;
    }
  }
}

.pointer {
  cursor: pointer;
}

.comp-list {
  & + .comp-list {
    margin-top: 30px;
  }
}

.no-competence {
  max-width: 300px;
  text-align: center;
  margin: auto;
  font-size: 1.3rem;
  opacity: 0.7;
  line-height: 1.2;
}

.swal2-loading .swal2-confirm {
  display: none;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.75);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.inactive.pointer {
  filter: grayscale(1);
  cursor: not-allowed;
}

.rda-viewlist {
  margin-left: 0;
  margin-right: 0;
}

.title-align {
  max-width: 832px !important;

  h4,
  h5 {
    text-align: justify !important;
  }
}

.title-view-rda {
  font-size: 22px;
}

.competence-details {
  color: #b23066;
  font-weight: 700;
}

.tematic-unit-title {
  color: #36b67d;
  font-weight: 600;
  font-size: 18px;
}

.comp-description {
  padding-right: 40px !important;
  font-size: 16px !important;
  line-height: 20px;
}

.knowledge-object-title {
  font-weight: 600;
  font-size: 16px;
}

.topic-description {
  font-size: 14px;
  line-height: 18px;
}

.level-group {
  margin: 15px 0;
  padding-left: 20px;

  .modality-content {
    background-color: #f8f9fa;
  }
}

::v-deep .card-header {
  background-color: #f7f7f7;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);

  &.accordion-header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.15s;

    &:hover {
      background-color: #e9ecef;
    }

    &:after {
      background: #868e96;
      display: block;
      content: "";
      -webkit-mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      mask: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='currentColor' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e")
        no-repeat 50% 50%;
      -webkit-mask-size: cover;
      mask-size: cover;
      width: 20px;
      height: 20px;
      transition: all 0.15s;
      transform: rotate(0deg);
      flex-shrink: 0;
    }

    &[aria-expanded="true"]:after {
      transform: rotate(180deg);
    }
  }

  h5 {
    margin: 0;
    color: #495057;
    font-weight: 600;
    pointer-events: none;

    &:hover {
      color: #495057;
    }
  }
}
</style>
